import { render, staticRenderFns } from "./TabYoureIt.vue?vue&type=template&id=95a42dc8&scoped=true&"
import script from "./TabYoureIt.vue?vue&type=script&lang=js&"
export * from "./TabYoureIt.vue?vue&type=script&lang=js&"
import style0 from "./TabYoureIt.vue?vue&type=style&index=0&id=95a42dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a42dc8",
  null
  
)

export default component.exports